<template>
  <div v-loading="loading" class="warpscreen">
    <div class="screenwarp">
      <div class="screentitle">{{tablename}} 价格分析表</div>
      <div class="screenright">
        <!-- <el-select v-model="cinvname" filterable placeholder="请选择" popper-class="selectFrom" class="selectjg" :remote-method="selectBlur" :loading="searchloading">
          <el-option v-for="item in options" :key="item.csrminvcode" :label="item.cinvname" :value="item.csrminvcode">
          </el-option>
        </el-select> -->
        <el-select v-model="cinvname" filterable remote reserve-keyword placeholder="请输入物料名称" clearable class="selectjg" @change="currentSel" popper-class="selectFrom" :remote-method="remoteMethod" :loading="searchloading">
          <el-option v-for="item in options" :key="item.csrminvcode" :label="item.cinvname" :value="item.csrminvcode">
          </el-option>
        </el-select>
        <div class="selectjg">
          <el-date-picker v-model="newdate" type="month" placeholder="选择年月" :clearable="false" popper-class="selectFrom" @change="GetReportMatPriceGraph()" value-format="yyyy-MM">
          </el-date-picker>
        </div>
        <div class="selectjg selectjg0">
          <span>{{chtstart}}</span>
        </div>
      </div>
    </div>
    <div class="fenxilist">
      <div class="muleft">
        <div class="muchang">
          <visreenjg :regBase="regBase" v-if="regBaseif" @regB="regB" />

        </div>
        <div class="muchang">
          <visreenmc :regBase1="regBase1" v-if="regBaseif1" @regA="regA" />
        </div>
      </div>
      <div class="muright">
        <div class="mutableall">
          <p>{{regBasename}}</p>
          <div class="mutable">

            <mcfenxiall :tableData="tabledata1" :tableLabel="tableLabelall" v-if="regtable1if" />
          </div>
        </div>
        <div class="mutableall">
          <p>{{regBasename1}}</p>
          <div class="mutable">

            <mcfenxi :tableData="tabledata2" :tableLabel="tableLabel" v-if="regtable2if" />
          </div>
        </div>
      </div>
      <div style=" clear:both">
      </div>
    </div>

    <div style="clear:both"></div>
  </div>
</template>

<script>
import visreenmc from "./echarts/visreenmc.vue";
import visreenjg from "./echarts/visreenjg.vue";
import mcfenxi from "./table/mcfenxi.vue";
import mcfenxiall from "./table/mcfenxiall.vue";
import { getUrlKey } from "../../api/home";
export default {
  components: {
    visreenmc,
    visreenjg,
    mcfenxi,
    mcfenxiall,
  },
  data() {
    return {
      loading: false,
      cztname: "",
      options: [],
      newdate: "",
      newdateecharts: "",
      chtstart: "",
      cop: "",
      cinvcod: "",
      // tableLabel表头数据：prop字段名
      tableLabel: [
        { label: "厂商", width: "", minwidth: "200", prop: "cvenname" },
        { label: "订单", width: "80", minwidth: "80", prop: "iorderqty" },
        { label: "单价", width: "80", minwidth: "80", prop: "iprice" },
        { label: "年份", width: "100", minwidth: "100", prop: "iyear" },
      ],
      tableLabelall: [
        { label: "厂商", width: "", minwidth: "200", prop: "cvenname" },
        { label: "合同可用量", width: "100", minwidth: "100", prop: "inowqty" },
        // { label: "执行量", width: "90", minwidth: "90", prop: "inowqty" },
        { label: "单价", width: "60", minwidth: "60", prop: "iprice" },
        // { label: "类型", width: "60", minwidth: "60", prop: "ctype" },
        { label: "牧场", width: "", minwidth: "160", prop: "cztname" },
      ],
      echartsdata: [],
      regBase: {
        name: "",
        cztname: [],
        vcont1: [],
        vcont2: [],
        vcont3: [],
        vcont4: [],
        vcont5: [],
        vcont6: [],
      },
      regBaseif: false,
      tabledata1: [],
      echartsdata2: [],
      regBase1: {
        name: "",
        imonth: [],
        vcont1: [],
        vcont2: [],
        vcont3: [],
        vcont4: [],
        vcont5: [],
      },
      regBaseif1: false,
      tabledata2: [],
      cinvname: "",
      searchloading: false,
      regtable1if: false,
      regtable2if: false,
      tablename: "",
      regBasename: "",
      regBasename1: "",
    };
  },

  created() {
    // var a = Request.Form["SourceData2"].ToString();
    // console.log(Request.Form);
    // localStorage.setItem("cop", "admin");
    console.log(localStorage.getItem("cop"));
    if (localStorage.getItem("cop")) {
      this.cop = localStorage.getItem("cop");
    } else if (getUrlKey("cop")) {
      this.cop = getUrlKey("cop");
    }

    this.cinvcod = getUrlKey("cinvcod");
    this.GetInvList();
    this.GetInvListname();
    this.nowTimes();
    this.GetReportMatPriceGraph();
  },

  methods: {
    // 点击echarts
    regB(val) {
      this.cztname = val;
      this.GetReportMatPriceGraph2();
    },
    // 点击echarts
    regA(val) {
      if (val >= 1 && val <= 9) {
        val = "0" + val;
      }

      this.newdateecharts = val;
      console.log(this.newdate);
      // this.newdate = val;
      this.GetReportMatPriceGraph3();
    },
    // 搜索物料
    remoteMethod(query) {
      console.log(query, this.cinvname);
      this.cinvname = query;
      this.searchloading = true;
      setTimeout(() => {
        this.searchloading = false;
        this.GetInvList();
        // this.GetInvListname();
      }, 200);
    },
    currentSel(val) {
      if (val != "") {
        this.cinvcod = val;
      } else {
        this.cinvcod = getUrlKey("cinvcod");
      }
      this.GetInvListname();
      this.GetReportMatPriceGraph();
    },
    // 数据查询
    GetReportMatPriceGraph() {
      this.echartsdata = [];
      this.tabledata1 = [];
      this.echartsdata2 = [];
      this.tabledata2 = [];
      this.regBase = {
        name: "",
        cztname: [],
        vcont1: [],
        vcont2: [],
        vcont3: [],
        vcont4: [],
        vcont5: [],
        vcont6: [],
      };
      this.regBase1 = {
        name: "",
        imonth: [],
        vcont1: [],
        vcont2: [],
        vcont3: [],
        vcont4: [],
        vcont5: [],
      };
      this.regBaseif = false;
      this.regBaseif1 = false;
      this.regtable1if = false;
      this.regtable2if = false;
      this.loading = true;
      if (this.newdate == "" || this.newdate == null) {
        var date1 = new Date();
        var year1 = date1.getFullYear();

        var month1 = date1.getMonth() + 1;
        if (month1 >= 1 && month1 <= 9) {
          month1 = "0" + month1;
        }
        this.newdate = year1 + "-" + month1;
      }
      this.$axios({
        method: "post",
        url: "CommonModule/Op_SupplierDD/GetReportMatPriceGraph1",
        data: {
          cop: this.cop,
          iyear: this.newdate.substring(0, 4),
          imonth: this.newdate.substring(5, 7),
          cinvcod: this.cinvcod,
        },
      })
        .then((res) => {
          if (res.data.Success) {
            console.log(res);
            this.loading = false;
            this.echartsdata = res.data.Data.Table;
            if (this.echartsdata.length != 0) {
              this.cztname = this.echartsdata[0].cztname;
            }

            console.log(this.echartsdata);
            this.regBase.name =
              this.newdate.substring(0, 4) +
              "年" +
              this.newdate.substring(5, 7) +
              "月" +
              "各牧场价格分析";

            for (let a = 0; a < this.echartsdata.length; a++) {
              this.regBase.cztname.push(this.echartsdata[a].cztname);
              this.regBase.vcont1.push(this.echartsdata[a].iasknum);
              this.regBase.vcont2.push(this.echartsdata[a].iorderqty);
              this.regBase.vcont3.push(this.echartsdata[a].ihtqty);
              this.regBase.vcont4.push(this.echartsdata[a].imaxprice);
              this.regBase.vcont5.push(this.echartsdata[a].iminprice);
              this.regBase.vcont6.push(this.echartsdata[a].iavgprice);
            }

            this.regBaseif = true;
            this.tabledata1 = res.data.Data.Table1;
            this.echartsdata2 = res.data.Data.Table2;
            this.regBasename = "各牧场执行中合同详情";
            for (let b = 0; b < this.echartsdata2.length; b++) {
              this.regBase1.imonth.push(this.echartsdata2[b].imonth + "月");
              this.regBase1.vcont1.push(this.echartsdata2[b].iorderqty);
              this.regBase1.vcont2.push(this.echartsdata2[b].imaxprice);
              this.regBase1.vcont3.push(this.echartsdata2[b].iminprice);
              this.regBase1.vcont4.push(this.echartsdata2[b].ifmaxprice);
              this.regBase1.vcont5.push(this.echartsdata2[b].ifminprice);
            }
            if (this.echartsdata2.length != 0) {
              this.regBase1.name =
                this.echartsdata2[0].cztname +
                " " +
                this.newdate.substring(0, 4) +
                "年" +
                " " +
                "采购量价格分析";
              this.regBasename1 =
                this.echartsdata2[0].cztname +
                " " +
                this.newdate.substring(0, 4) +
                "年" +
                this.newdate.substring(5, 7) +
                "月" +
                " " +
                "订单详情";
            } else {
              this.regBase1.name =
                this.newdate.substring(0, 4) + "年" + "采购量价格分析";
              this.regBasename1 =
                this.newdate.substring(0, 4) +
                "年" +
                this.newdate.substring(5, 7) +
                "月" +
                "订单详情";
            }
            this.regBaseif1 = true;
            this.tabledata2 = res.data.Data.Table3;

            this.regtable1if = true;
            this.regtable2if = true;
          } else {
            this.$message.error(res.data.Message);
          }
        })
        .catch((error) => {
          this.loading = false;
        });
    },

    // /CommonModule/Op_SupplierDD/GetReportMatPriceGraph3
    GetReportMatPriceGraph2() {
      this.tabledata1 = [];
      this.echartsdata2 = [];
      this.tabledata2 = [];

      this.regBase1 = {
        name: "",
        imonth: [],
        vcont1: [],
        vcont2: [],
        vcont3: [],
        vcont4: [],
        vcont5: [],
      };
      this.regBaseif1 = false;
      this.regtable1if = false;
      this.regtable2if = false;
      this.loading = true;
      if (this.newdate == "" || this.newdate == null) {
        var date1 = new Date();
        var year1 = date1.getFullYear();

        var month1 = date1.getMonth() + 1;
        if (month1 >= 1 && month1 <= 9) {
          month1 = "0" + month1;
        }
        this.newdate = year1 + "-" + month1;
      }
      this.$axios({
        method: "post",
        url: "CommonModule/Op_SupplierDD/GetReportMatPriceGraph2",
        data: {
          cop: this.cop,
          iyear: this.newdate.substring(0, 4),
          imonth: this.newdate.substring(5, 7),
          cztname: this.cztname,
        },
      })
        .then((res) => {
          if (res.data.Success) {
            console.log(res);
            this.loading = false;

            this.tabledata1 = res.data.Data.Table;
            this.echartsdata2 = res.data.Data.Table1;
            this.regBasename = this.cztname + "执行中合同详情";
            console.log(this.regBase1);
            for (let b = 0; b < this.echartsdata2.length; b++) {
              this.regBase1.imonth.push(this.echartsdata2[b].imonth + "月");
              this.regBase1.vcont1.push(this.echartsdata2[b].iorderqty);
              this.regBase1.vcont2.push(this.echartsdata2[b].imaxprice);
              this.regBase1.vcont3.push(this.echartsdata2[b].iminprice);
              this.regBase1.vcont4.push(this.echartsdata2[b].ifmaxprice);
              this.regBase1.vcont5.push(this.echartsdata2[b].ifminprice);
            }
            this.regBase1.name =
              this.cztname +
              " " +
              this.newdate.substring(0, 4) +
              "年" +
              " " +
              "采购量价格分析";
            this.regBasename1 =
              this.cztname +
              " " +
              this.newdate.substring(0, 4) +
              "年" +
              this.newdate.substring(5, 7) +
              "月" +
              " " +
              "订单详情";
            this.regBaseif1 = true;
            this.tabledata2 = res.data.Data.Table2;
            this.regtable1if = true;
            this.regtable2if = true;
          } else {
            this.$message.error(res.data.Message);
          }
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    // /CommonModule/Op_SupplierDD/GetReportMatPriceGraph3
    GetReportMatPriceGraph3() {
      this.tabledata2 = [];

      this.regtable2if = false;
      this.loading = true;
      if (this.newdate == "" || this.newdate == null) {
        var date1 = new Date();
        var year1 = date1.getFullYear();

        var month1 = date1.getMonth() + 1;
        if (month1 >= 1 && month1 <= 9) {
          month1 = "0" + month1;
        }
        this.newdate = year1 + "-" + month1;
      }
      this.$axios({
        method: "post",
        url: "CommonModule/Op_SupplierDD/GetReportMatPriceGraph3",
        data: {
          cop: this.cop,
          iyear: this.newdate.substring(0, 4),
          imonth: this.newdateecharts,
          cztname: this.cztname,
        },
      })
        .then((res) => {
          if (res.data.Success) {
            console.log(res);
            this.loading = false;
            this.tabledata2 = res.data.Data;
            this.regBasename1 =
              this.cztname +
              " " +
              this.newdate.substring(0, 4) +
              "年" +
              this.newdateecharts +
              "月" +
              " " +
              "订单详情";
            this.regtable2if = true;
          } else {
            this.$message.error(res.data.Message);
          }
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    //物料
    GetInvList() {
      this.options = [];
      this.$axios({
        method: "post",
        url: "CommonModule/Op_SupplierDD/GetInvList",
        data: {
          cinvname: this.cinvname,
        },
      })
        .then((res) => {
          if (res.data.Success) {
            console.log(res);
            this.options = res.data.Data;
          } else {
            this.$message.error(res.data.Message);
          }
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    //物料
    GetInvListname() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_SupplierDD/GetInvList",
        data: {
          csrminvcode: this.cinvcod,
        },
      })
        .then((res) => {
          if (res.data.Success) {
            this.tablename = res.data.Data[0].cinvname;
            console.log(this.tablename);
          } else {
            this.$message.error(res.data.Message);
          }
        })
        .catch((error) => {
          this.loading = false;
        });
    },

    // 获取当前时间
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var seperator2 = " ";
      var seperator3 = ":";
      var year = date.getFullYear();

      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }

      var currentdate =
        year +
        seperator1 +
        month +
        seperator1 +
        strDate +
        seperator2 +
        date.getHours() +
        seperator3 +
        date.getMinutes() +
        seperator3 +
        date.getSeconds();

      this.chtstart = currentdate;
    },
    nowTimes() {
      this.getNowFormatDate();
      setInterval(this.nowTimes, 1000);
      this.clear();
    },
    clear() {
      clearInterval(this.nowTimes);
      this.nowTimes = null;
    },
  },
};
</script>
<style scoped>
@import url(../../assets/css/viscreen.css);
.el-table td,
.el-table th.is-leaf,
.el-table--border,
.el-table--group {
  border-color: black;
}
.el-table--border::after,
.el-table--group::after,
.el-table::before {
  background-color: black;
}
</style>
